/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TaskDetailsAliases {
  AVATAR_1 = 'avatar-1',
  AVATAR_TASK = 'avatar-task',
  CARD_0 = 'card-0',
  CARD_INDICATORS = 'card-indicators',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTEXTUAL_BAR_ITENS = 'contextual-bar-itens',
  DECK_INDICATORS = 'deck-indicators',
  FETCH_TASK_DETAILS = 'fetch-task-details',
  FETCH_TASK_ITENS = 'fetch-task-itens',
  FIELD_0 = 'field-0',
  FIELD_ACTION = 'field-action',
  FIELD_AVATAR = 'field-avatar',
  FIELD_COMPETENCE = 'field-competence',
  FIELD_CONCLUSION_DATE = 'field-conclusion-date',
  FIELD_DOC_TYPE = 'field-doc-type',
  FIELD_INDICATOR_TYPE = 'field-indicator-type',
  FIELD_MEETING_MINUTES = 'field-meeting-minutes',
  FIELD_STATUS_INDICATOR = 'field-status-indicator',
  FORM_0 = 'form-0',
  LAYOUT_2 = 'layout-2',
  MAPPER_1 = 'mapper-1',
  MAPPER_AVATAR = 'mapper-avatar',
  PANEL_2 = 'panel-2',
  PANEL_TASK_DETAIL = 'panel-task-detail',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_ACTION = 'text-action',
  TEXT_MEETING_MINUTES = 'text-meeting-minutes',
}
export { TaskDetailsAliases };
